module.exports = __webpack_public_path__ + "static/img/mobilestep3.2d6b79d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/mobilestep3.png
// module id = HlW0
// module chunks = 1